import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp, commonData } from "@/mixins/index";
import Editor from "@/components/Editor";
export default {
  components: {
    Editor: Editor
  },
  mixins: [popUp, commonData],
  data: function data() {
    var _this = this;

    var checkContentValid = function checkContentValid(content) {
      if (!content) return false; // 1. 如果包含图片/视频/音频/iframe标签，直接认定有内容

      var hasMedia = /<(img|video|audio|iframe)[^>]*>/i.test(content);
      if (hasMedia) return true; // 2. 剔除所有标签及空格占位符后，检查是否有实际文本

      var cleanText = content.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, "").trim();
      return cleanText.length > 0;
    }; // 1. 用户协议二选一校验


    var validateUserAgreement = function validateUserAgreement(rule, value, callback) {
      var url = !!(_this.formData.user_agreement_url && _this.formData.user_agreement_url.trim());
      var hasContent = checkContentValid(_this.formData.user_agreement_content);

      if (!url && !hasContent) {
        callback(new Error("用户协议地址与内容必须填写其中一项"));
      } else if (url && hasContent) {
        callback(new Error("用户协议地址与内容只能二选一，不能同时填写"));
      } else {
        callback();
      }
    }; // 2. 隐私协议二选一校验


    var validatePrivacyAgreement = function validatePrivacyAgreement(rule, value, callback) {
      var url = !!(_this.formData.privacy_agreement_url && _this.formData.privacy_agreement_url.trim());
      var hasContent = checkContentValid(_this.formData.privacy_agreement_content);

      if (!url && !hasContent) {
        callback(new Error("隐私协议地址与内容必须填写其中一项"));
      } else if (url && hasContent) {
        callback(new Error("隐私协议地址与内容只能二选一，不能同时填写"));
      } else {
        callback();
      }
    };

    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        appid: "",
        user_agreement_url: "",
        user_agreement_content: "",
        privacy_agreement_url: "",
        privacy_agreement_content: ""
      },
      rules: {
        appid: [{
          required: true,
          message: "请选择应用",
          trigger: "change"
        }],
        user_agreement_url: [{
          validator: validateUserAgreement,
          trigger: ["blur", "change"]
        }],
        user_agreement_content: [{
          validator: validateUserAgreement,
          trigger: ["blur", "change"]
        }],
        privacy_agreement_url: [{
          validator: validatePrivacyAgreement,
          trigger: ["blur", "change"]
        }],
        privacy_agreement_content: [{
          validator: validatePrivacyAgreement,
          trigger: ["blur", "change"]
        }]
      }
    };
  },
  methods: {
    // 清洗富文本的方法
    cleanHtmlTag: function cleanHtmlTag(content) {
      if (!content) return "";
      var hasMedia = /<(img|video|audio|iframe)[^>]*>/i.test(content);
      if (hasMedia) return content;
      var cleanText = content.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, "").trim();
      return cleanText.length > 0 ? content : "";
    },
    init: function init(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var d;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.copyPrimitive();

                _context.next = 3;
                return _this2.getcommonData(["appListAllData"]);

              case 3:
                if (data) {
                  d = JSON.parse(JSON.stringify(data));
                  Object.keys(_this2.formData).forEach(function (item) {
                    _this2.formData[item] = d[item] || "";
                  });
                  _this2.formData.user_agreement_content = _this2.$utils.textRepl(_this2.formData.user_agreement_content);
                  _this2.formData.privacy_agreement_content = _this2.$utils.textRepl(_this2.formData.privacy_agreement_content);
                }

                _this2.copyData();

                _this2.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleInput: function handleInput(targetProp) {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.$refs.ruleForm) {
          _this3.$refs.ruleForm.clearValidate(targetProp);

          _this3.$refs.ruleForm.validateField(targetProp);
        }
      });
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);

      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate();
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 11;
                    break;
                  }

                  if (!_this4.formData.id) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return _this4.secondConfirmation();

                case 4:
                  data = JSON.parse(JSON.stringify(_this4.formData)); // 提交给后端前，将只有空标签的富文本处理为 ''

                  data.user_agreement_content = _this4.cleanHtmlTag(data.user_agreement_content);
                  data.privacy_agreement_content = _this4.cleanHtmlTag(data.privacy_agreement_content);
                  data.user_agreement_content = data.user_agreement_content.replaceAll(_this4.$imgUrl, '');
                  data.privacy_agreement_content = data.privacy_agreement_content.replaceAll(_this4.$imgUrl, '');
                  reqFn = data.id ? "appUserAgreementUpdate" : "appUserAgreementAdd";

                  _this4.$api[reqFn](_objectSpread({}, data)).then(function (res) {
                    if (res.status == 200) {
                      _this4.$message({
                        message: "操作成功",
                        type: "success"
                      });

                      _this4.dialogFormVisible = false;

                      _this4.$emit("change");
                    } else {
                      _this4.$message({
                        message: res.message,
                        type: "error"
                      });
                    }
                  });

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};